import { createApolloFetch } from 'apollo-fetch';
import { graphQLEndpoint } from './constants';

export * from './router';
export { default as cx } from 'classnames';
export { default as autobind } from 'autobind-decorator';

export function isDev() {
  return process.env.NODE_ENV === 'development';
}

export const apolloFetch = createApolloFetch({ uri: graphQLEndpoint });
